/* Verri redesign (6 Oct 2026): pack picker, sticky add-to-cart, cart drawer bundle swap,
   and a bridge that points old /collections/all links at the manually sorted collection. */
(function () {
  'use strict';

  function money(text) { return text || ''; }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: null } }));
  }

  /* 1. Pack picker on product pages */
  function initPicker(picker) {
    var form = picker.closest('form') || (picker.parentElement && picker.parentElement.querySelector('form'));
    var scope = picker.closest('[data-product-blocks]') || document;
    if (!form) form = scope.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var btn = form.querySelector('[data-add-to-cart]') || form.querySelector('button[type="submit"]');
    var btnText = btn ? (btn.querySelector('[data-add-to-cart-text]') || btn) : null;
    var current = picker.getAttribute('data-current-variant');
    var stickyName = document.querySelector('[data-v-sticky-name]');

    function selected() { return picker.querySelector('input[type="radio"]:checked'); }

    function update() {
      var s = selected(); if (!s) return;
      picker.querySelectorAll('.v-opt').forEach(function (o) { o.classList.toggle('is-selected', o.contains(s)); });
      if (btnText) btnText.textContent = 'Add to cart · ' + money(s.dataset.price);
      if (stickyName) stickyName.textContent = s.dataset.name + ' · ' + money(s.dataset.price);
    }
    picker.querySelectorAll('input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', update); r.addEventListener('input', update);
    });
    picker.addEventListener('click', function () { setTimeout(update, 0); });
    update();

    if (btn) {
      btn.addEventListener('click', function (e) {
        var s = selected();
        if (!s || s.value === current) return; // normal theme add for the product on this page
        e.preventDefault(); e.stopImmediatePropagation();
        btn.classList.add('btn--loading');
        addToCart(s.value).then(function () {
          btn.classList.remove('btn--loading'); refreshDrawer();
        }).catch(function () { btn.classList.remove('btn--loading'); window.location.href = '/cart/add?id=' + s.value + '&quantity=1'; });
      }, true);
    }
  }

  /* 2. Sticky add-to-cart bar (mobile) */
  function initSticky(bar) {
    var main = document.querySelector('.template-product [data-add-to-cart]');
    var sbtn = bar.querySelector('[data-v-sticky-btn]');
    if (!main) return;
    sbtn.addEventListener('click', function () { main.click(); });
    if (!('IntersectionObserver' in window)) return;
    var seen = false;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { seen = true; bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden', 'true'); sbtn.tabIndex = -1; }
        else if (seen || en.boundingClientRect.top < 0) { bar.classList.add('is-visible'); bar.setAttribute('aria-hidden', 'false'); sbtn.tabIndex = 0; }
      });
    }, { threshold: 0 }).observe(main);
  }

  /* 3. Cart drawer: swap a starter kit for the Festival Bundle */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-v-swap]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true; b.classList.add('btn--loading');
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: b.dataset.lineKey, quantity: 0 })
    }).then(function () { return addToCart(b.dataset.bundleVariant); })
      .then(refreshDrawer)
      .catch(function () { window.location.href = '/cart'; });
  });

  /* 4. Bridge: menu "Shop all" still points at /collections/all (A to Z, venue kit second).
        Send those links to the manually sorted collection until the menu itself is updated. */
  function fixShopAll() {
    document.querySelectorAll('a[href="/collections/all"], a[href="https://verri.com.au/collections/all"]').forEach(function (a) {
      a.setAttribute('href', '/collections/all-products');
    });
  }

  function init() {
    document.querySelectorAll('[data-v-picker]').forEach(initPicker);
    document.querySelectorAll('[data-v-sticky]').forEach(initSticky);
    fixShopAll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
